module.exports = __webpack_public_path__ + "img/ícone-seta-direita-azul.96532ccc.svg";